import { Icon, IconProps } from "@chakra-ui/icons";

const DownloadIcon = (props: IconProps) => {
  return (
    <Icon width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M11.9987 14.8997C11.8988 14.8997 11.8088 14.8797 11.7188 14.8497C11.6388 14.8197 11.5687 14.7697 11.4987 14.7097L8.49875 11.7097C8.20875 11.4197 8.20875 10.9397 8.49875 10.6497C8.78875 10.3597 9.26875 10.3597 9.55875 10.6497L11.2787 12.3697V6.92969C11.2787 6.51969 11.6187 6.17969 12.0287 6.17969C12.4387 6.17969 12.7787 6.51969 12.7787 6.92969V12.3697L14.4988 10.6497C14.7888 10.3597 15.2688 10.3597 15.5588 10.6497C15.8488 10.9397 15.8488 11.4197 15.5588 11.7097L12.5588 14.7097C12.4988 14.7697 12.4288 14.8097 12.3488 14.8397C12.2588 14.8797 12.1588 14.8997 12.0588 14.8997H11.9987Z"
        fill="#171717"
      />
      <path
        d="M16.5 17.6484H7.5C7.09 17.6484 6.75 17.3084 6.75 16.8984C6.75 16.4884 7.09 16.1484 7.5 16.1484H16.5C16.91 16.1484 17.25 16.4884 17.25 16.8984C17.25 17.3084 16.91 17.6484 16.5 17.6484Z"
        fill="#171717"
      />
      <path
        d="M12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25ZM12 3.25C7.18 3.25 3.25 7.18 3.25 12C3.25 16.82 7.18 20.75 12 20.75C16.82 20.75 20.75 16.83 20.75 12C20.75 7.17 16.83 3.25 12 3.25Z"
        fill="#171717"
      />
    </Icon>
  );
};

export default DownloadIcon;
